// removed by extract-text-webpack-plugin
module.exports = {"upload-methods":"alternative-upload-methods__upload-methods___pczqT","upload-title":"alternative-upload-methods__upload-title___2RQrV","upload-image":"alternative-upload-methods__upload-image___1s4-r","upload-image-container":"alternative-upload-methods__upload-image-container___1cf_I","tooltip":"alternative-upload-methods__tooltip___15fs9"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/alternative-upload-methods.scss
// module id = 1367
// module chunks = 0